import { FieldErrors } from 'react-hook-form'
import { Moment } from 'moment'

import { AppDateFormats } from 'Core/constants'
import { CustomGenerator, PreviewSections } from 'Core/interfaces'

export enum GenerateReportFormFields {
	sqlParameters = 'sqlParameters',
	reportSqlParameters = 'reportSqlParameters',
	reportWhereParameters = 'reportWhereParameters',
	reportColumnIdsParameters = 'reportColumnIdsParameters',
	reportId = 'reportId',
	invoiceId = 'invoiceId'
}

export declare namespace DataReport {
	type BasicType = 0 | 1
	type BasicStatus = 0 | 1 | 2 | 3
	type BasicStatusNames = 'activate' | 'incomplete' | 'archived' | 'restore'
	interface ParametersTypeOptions extends Entity {
		extra: PreviewSections | null
	}
	interface Basic {
		either?: boolean
		isValid?: boolean
		or?: boolean
		fieldName?: PreviewSections | null
		label?: string | null
		isRequired?: boolean
		validationGroup?: string | null
		value: LabelValue | Key | boolean | Moment | null | undefined | LabelValue[]
		id: number
	}

	interface ResponseReportWhereParameters {
		id: number
		label: BasicString
		parameterType: Entity
		parameter: Entity
		isRequired: boolean
		either: boolean
		or: boolean
		validationGroup: BasicString
		userType: BasicString
	}

	interface ResponseSqlParameters {
		id: number
		parameter: Entity
		label: BasicString
		parameterType: Entity
		isRequired?: boolean
	}

	interface ReportColumn extends Entity {
		sortOrder: number
	}
	interface Detailed extends Entity<BasicString> {
		type: BasicType
		status: BasicStatus
		description: BasicString
		tags: Entity[]
		lastChangeDate: BasicString
		lastUser: BasicString
		comments: BasicString
		category: Entity | null
		selectClause: BasicString
		fromClause: BasicString
		whereClause: BasicString
		groupByClause: BasicString
		orderByClause: BasicString
		columns: BasicString
		reportColumns: ReportColumn[]
		reportWhereParameters: ResponseReportWhereParameters[]
		sqlParameters: ResponseSqlParameters[]
		isRestrictedByServiceSite: boolean
		serviceSiteIdColumn: BasicString
	}
	interface ReportWhereParameters extends Omit<ResponseReportWhereParameters, 'parameterType'> {
		parameterType: ParametersTypeOptions
	}
	interface SqlParameters extends Omit<ResponseSqlParameters, 'parameterType'> {
		parameterType: ParametersTypeOptions
	}

	interface Data extends Omit<Detailed, 'reportWhereParameters' | 'sqlParameters'> {
		reportWhereParameters: ReportWhereParameters[]
		sqlParameters: SqlParameters[]
	}
	interface Form {
		[GenerateReportFormFields.sqlParameters]: Basic[]
		[GenerateReportFormFields.reportWhereParameters]: Basic[]
		[GenerateReportFormFields.reportColumnIdsParameters]: LabelValue<number>[]
	}

	interface GenericGenerateForm extends Form {
		[GenerateReportFormFields.reportId]: BasicNumber
	}

	interface Request {
		[GenerateReportFormFields.reportSqlParameters]: IdValue<string | null>[]
		[GenerateReportFormFields.reportWhereParameters]: IdValue<string | null>[]
		[GenerateReportFormFields.reportColumnIdsParameters]: number[]
	}
}

export interface PreviewProps {
	parameterData: DataReport.ReportWhereParameters | DataReport.SqlParameters
	fieldName: string
	error?: FieldErrors
	isSqlParameter?: boolean
	retrievePreviewOptions: (
		parameterId: Key,
		query?: string | undefined
	) => CustomGenerator<ValueDescription[], LabelValue<string>[] | undefined>
	isDisabledPreviewFields?: boolean
	getCurrentDateFormat: AppDateFormats
	onSearchFind: (parameterId: Key, query?: string) => Promise<ValueDescription[]>
}
